import React, { useState } from 'react'
import {
    Grid,
    Button,
    Dialog,
    DialogContent,
    useTheme,
    useMediaQuery,

} from "@material-ui/core";
import DynamicInput from '../InputComponents/DynamicInput';
import { States } from '../../helpers/state';
import services from '../../Services';
import Text from 'antd/lib/typography/Text';
import { Modal } from 'antd';
import { formatZip } from '../../helpers/formatedNumber';


const { hr } = services;
const AddressModal = ({ addressData }) => {

    let { employeeDetails, open, close, setStateName, stateName, emergencyContact, getEmployeeDetails } = addressData;
    const theme = useTheme();

    const [streedAddress, setStreedAddress] = useState(employeeDetails?.address)
    const [streedAddress1, setStreedAddress1] = useState(employeeDetails?.address1 == '' ? "null" : employeeDetails?.address1)
    const [city, setCity] = useState(employeeDetails?.city)
    const [zip, setZip] = useState(employeeDetails.zip)
    const [error, setError] = useState('')

    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const filterCurrentstreetStatus = (key) => {
        let obj = States?.filter(value => value?.abbreviation == key)
        return obj[0]
    }



    let fields = [
        { type: 1, name: "Employee ID", initial: employeeDetails?.id, isDisabled: true },
        {
            type: 1, name: "Street Address1", initial: streedAddress, isRequired: true,
            onChange: (value) => setStreedAddress(value)
        },
        { type: 1, name: "Street Address2", isRequired: false, initial: streedAddress1, onChange: (value) => setStreedAddress1(value) },
        { type: 1, name: "City", isRequired: true, initial: city, onChange: (value) => setCity(value) },
        { type: 3, key: 'title', options: States, name: "State", initial: filterCurrentstreetStatus(stateName), isRequired: 'true', onChange: (newValue) => setStateName(newValue?.abbreviation) },
        { type: 1, name: "Zip", isRequired: true, initial: zip, onChange: (value) => setZip(value.replace(/\D/g, "")), maxlength: 5 },

    ]

    async function onSubmitModal() {

        let data = {
            address_1: streedAddress || ' ',
            address_2: streedAddress1 || ' ',
            state: stateName,
            zip: zip,
            employee_id: employeeDetails?.id,
            city: city,
            abbrivation: States.find(item => item?.abbreviation === emergencyContact?.state?.toUpperCase())
        }

        try {
            hr.updateEmployeeAddress(data)
                .then((update) => {
                    close(false);

                }).then(() => {
                    getEmployeeDetails();

                })
                .catch(err => {
                     

                })
        } catch (exc) {
             
        }

    }


    return (
        <div className='address-modal'>
            <Modal className='address-modal' open={open} onCancel={() => close(false)} footer={false}
                closeIcon={<Button autoFocus className="ModalClose"></Button>}>
                <div style={{ padding: "10px" }}>
                    <DynamicInput fields={fields} />
                    <Text style={{ color: 'red' }} > {error}</Text>
                    <Grid xs={12} container justify="center" className="mt30">
                        <Button onClick={onSubmitModal} className="LinkButton">Save</Button>
                    </Grid>
                </div>
            </Modal>
        </div>
    )
}

export default AddressModal